export default class BackToTop {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    this.context.addEventListener('click', BackToTop.handleClick);
  }

  static handleClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
